import React, { memo, useCallback } from "react";
import { NodeProps, useReactFlow } from "reactflow";
import { NodeType } from "../../../models/nodeType";
import BaseNode from "../../../features/reactflow/nodes/base/BaseNode";
import { useForm } from "react-hook-form";
import { Box } from "@chakra-ui/react";
import SelectEquipmentSlot from "../../base/SelectEquipmentSlot";

interface FormData {
  slotName: string;
}

const PlayerHasEquipmentNode: React.FC<NodeProps<NodeType>> = (props) => {
  const {
    id: nodeId,
    data: { color, nodeData = {} },
  } = props;

  const formData = nodeData as FormData | undefined;
  const slotName = formData?.slotName;

  const { getValues, setValue, handleSubmit } = useForm<FormData>({
    defaultValues: {
      slotName,
    },
    mode: "onBlur",
  });

  const reactFlow = useReactFlow();

  const handleUpdate = useCallback(
    ({ slotName }: FormData) => {
      reactFlow.setNodes((nodes) => {
        const node = nodes.find(({ id }) => id === nodeId);

        if (node == null) {
          return nodes;
        }

        const nodeDataCloned = structuredClone(node.data) as NodeType;

        const nodeData = (nodeDataCloned.nodeData as FormData) ?? {};
        nodeData.slotName = slotName;

        node.data = {
          ...nodeDataCloned,
          nodeData,
        };

        return nodes;
      });
    },
    [reactFlow]
  );

  return (
    <BaseNode {...props}>
      <Box p={2}>
        <form className={"nodrag"} onSubmit={handleSubmit(handleUpdate)} onBlur={handleSubmit(handleUpdate)}>
          <SelectEquipmentSlot
            value={getValues("slotName")}
            setValue={(value) => setValue("slotName", value)}
            color={color}
          />
        </form>
      </Box>
    </BaseNode>
  );
};

export default memo(PlayerHasEquipmentNode);
